window.loadScript = function(url, callback) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  if (script.readyState) {
    // only required for IE <9
    script.onreadystatechange = function() {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
        callback()
      }
    }
  } else {
    // Others
    script.onload = function() {
      callback()
    }
  }

  script.src = url
  document.getElementsByTagName('head')[0].appendChild(script)
}

window.loadScripts = function(urls, callback) {
  if (urls && urls.length > 0) {
    const url = urls[0]
    urls.splice(0, 1)
    window.loadScript(url, () => {
      window.loadScripts(urls, callback)
    })
  } else if (callback) {
    callback()
  }
}
